import { ErrorHandler, Injectable } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';

@Injectable()
export class RavenErrorHandlerService implements ErrorHandler {

  static scrubHeader(key: string, values?: string[]): string[]|null {
    if (key.toLowerCase() === 'token') return ['<scrubbed>'];
    return values;
  }

  handleError(error: any): void {
    console.log('Error (captured)', error);
    const { captureError, extra } = this.transformError(error);
    Raven.captureException(captureError, { extra });
    // todo ?? return sentry ID? it's `Raven.lastEventId()`
    // They also have an embedded report dialog:
    // https://docs.sentry.io/clients/javascript/usage/#user-feedback
  }

  private transformError(error: any) {
    let extra = null;
    let captureError = error.originalError || error;  // https://docs.sentry.io/clients/javascript/integrations/angular/#systemjs
    if (captureError instanceof HttpErrorResponse) {
      extra = {
        httpErrorResponse: {
          ...captureError,
          // convert HttpHeaders to a serializable list
          headers: captureError.headers.keys()
            .map(key =>
              [key, RavenErrorHandlerService.scrubHeader(key, captureError.headers.getAll(key))])
        },
      };
      captureError = captureError.message;
    }
    return { captureError, extra };
  }
}



// WEBPACK FOOTER //
// ./src/app/core/raven/raven-error-handler.service.ts